import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererParams } from 'ag-grid-community';


export interface DialogDataTaskStatus {
	params;
	page;
}

@Component({
	selector: 'app-task-status',
	template: `
  <span [ngClass]="stylingClass">
  <img id="img2" width="14" height="14" *ngIf="imageSource" [src]="imageSource" (click)="btnClickedHandler($event)">
  </span> 
  <div class="status-box" [innerHtml]="htmlCode"></div>`,
	styleUrls: ['./task-status.component.scss'],
	standalone: false,  // NOSONAR
})

export class TaskStatusComponent implements OnInit {

	public imageSource: string;
	public value: any;
	public htmlCode: string;
	private params: any;
	showloaderMsg;
	status;
	stylingClass = "style-pointer";
	isEditable = false;

	agInit(params: ICellRendererParams): void {
		this.params = params;

		if (params.value && params.colDef.field != "OPERATING_PROCEDURE_URL") { // NOSONAR
			const regionData = params.value.split("|");
			this.status = regionData[0];
			if (regionData[3] == '1') { // NOSONAR
				this.isEditable = true;
			}
		}

		if (this.status == 'C') { // NOSONAR
			this.imageSource = '../../../assets/images/Ellipse 1.svg';
			this.value = params.value;
		}
		if (this.status == 'L') { // NOSONAR
			this.imageSource = '../../../assets/images/times-solid.svg';
			this.value = params.value;
		}
		if (this.status == 'F') { // NOSONAR
			this.imageSource = '../../../assets/images/ban-solid.svg';
			this.value = params.value;
		}

		//OP

		if (params.data.OPERATING_PROCEDURE_URL && params.colDef.field == "OPERATING_PROCEDURE_URL") { // NOSONAR
			if (params.data.OPERATING_PROCEDURE_URL == 'null') { // NOSONAR
				this.imageSource = '';
			}
			else {
				this.imageSource = '../../../assets/images/file_blue.svg';
			}
		} else if (!this.isEditable) {
			this.stylingClass = "style-no-drop";
		}



	}


	btnClickedHandler(_event) {

		if (this.params.data.OPERATING_PROCEDURE_URL && this.params.colDef.field == "OPERATING_PROCEDURE_URL") { // NOSONAR
			// route to this.params.data.OPERATING_PROCEDURE_URL
			window.location.href = this.params.data.OPERATING_PROCEDURE_URL;
		}

		if (!this.isEditable) {
			return;
		}

		// swicth status from completed / forgot to mark / late to open
		if (this.status == 'C' || this.status == 'F' || this.status == 'L') { // NOSONAR
			// call the function      
			this.params.context.componentParent.MAIStatusChangeDialog(this.params);
		}
	}

	constructor(public dialog: MatDialog) { }

	ngOnInit(): void { // NOSONAR
		//  do something 
	}

}
